module.exports = __webpack_public_path__ + "img/image6.14068879.webp";